import { useEffect } from "react";

export const DEFAULT_FAVICON_HREF = "/favicon.svg";
export const GRID_FAVICON_HREF = "/grid-icon.svg";

const FAVICON_TYPE_BY_EXTENSION: Record<string, string> = {
  ico: "image/x-icon",
  png: "image/png",
  svg: "image/svg+xml",
};

const getFaviconType = (href: string): string | undefined => {
  const extension = href.split("?")[0]?.split(".").pop()?.toLowerCase();
  return extension ? FAVICON_TYPE_BY_EXTENSION[extension] : undefined;
};

const getFaviconLink = (): HTMLLinkElement => {
  const existingLink = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  if (existingLink) {
    return existingLink;
  }

  const link = document.createElement("link");
  link.rel = "icon";
  document.head.appendChild(link);
  return link;
};

const useFavicon = (href = DEFAULT_FAVICON_HREF) => {
  useEffect(() => {
    const link = getFaviconLink();
    const type = getFaviconType(href);

    link.href = href;
    if (type) {
      link.type = type;
    } else {
      link.removeAttribute("type");
    }
  }, [href]);
};

export default useFavicon;
